import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M2.001 2.001H18v2H2.001v-2zM2.001 9H18v2H2.001V9zM2.001 16H18v2H2.001v-2z'],
  height: 20,
  width: 20,
});
